import Vue from "vue";
import VueRouter from "vue-router";
import AuthLayout from "../views/layouts/AuthLayout";
import MainLayout from "../views/layouts/MainLayout";
import TopNavLayout from "../views/layouts/TopNavLayout";
import RecordsNav from "../components/Navs/RecordsNav";
import NavigateBack from "../components/NavigateBack";
import Close from "../components/Close";

Vue.use(VueRouter);

const routes = [
  {
    path: "/legal",
    component: MainLayout,
    children: [
      {
        path: "privacy-policy",
        name: "privacy-policy",
        components: {
          default: () => import("../views/PrivacyPolicy"),
          back: NavigateBack,
        },
        meta: {
          title: "Privacy Policy",
          sub: true,
          hideSOS: true,
        },
      },
    ],
    meta: {
      privacy: true,
    },
  },
  {
    path: "/auth",
    component: AuthLayout,
    children: [
      {
        path: "login",
        name: "login",
        component: () => import("../views/Auth/Login"),
      },
      {
        path: "sign-up",
        name: "sign-up",
        component: () => import("../views/Auth/SignUp"),
      },
      {
        path: "add-patient",
        name: "add-patient",
        component: () => import("../views/Auth/SignUp"),
        meta: {
          addPatient: true,
        },
      },
      {
        path: "country",
        name: "country",
        component: () => import("../views/Auth/Country"),
        meta: {
          requiresGuest: false,
        },
      },
    ],
    meta: {
      requiresGuest: true,
    },
  },
  {
    path: "",
    component: MainLayout,
    redirect: "records",
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("../views/Home"),
        meta: {
          title: "Home",
          home: true,
        },
      },
      {
        path: "wallet",
        name: "wallet",
        component: () => import("../views/Wallet"),
        meta: {
          title: "Health Wallet",
        },
      },
      {
        path: "menu",
        name: "menu",
        component: () => import("../views/Menu"),
        meta: {
          menu: true,
        },
      },
      {
        path: "guide",
        name: "guide",
        components: {
          default: () => import("../views/Guide"),
          back: Close,
        },
        meta: {
          title: "Guide",
          sub: true,
        },
      },
      {
        path: "menu/contact-us",
        name: "contact us",
        components: {
          default: () => import("../views/Menus/ContactUs"),
          back: NavigateBack,
        },
        meta: {
          title: "Contact us",
          sub: true,
        },
      },
      {
        path: "menu/about-us",
        name: "about us",
        components: {
          default: () => import("../views/Menus/AboutUs"),
          back: NavigateBack,
        },
        meta: {
          title: "About us",
          sub: true,
        },
      },
      {
        path: "menu/privacy",
        name: "Privacy",
        components: {
          default: () => import("../views/Menus/Privacy"),
          back: () => import("../components/NavigateBack"),
        },
        meta: {
          title: "Privacy",
          sub: true,
        },
      },
      {
        path: "menu/health-care-providers",
        name: "health care providers",
        components: {
          default: () => import("../views/Menus/HealthCareProviders"),
          back: () => import("../components/NavigateBack"),
        },
        meta: {
          title: "POS",
          sub: true,
        },
      },
      {
        path: "menu/guide",
        name: "menu guide",
        components: {
          default: () => import("../views/Guide"),
          back: NavigateBack,
        },
        meta: {
          title: "Guide",
          sub: true,
        },
      },
      {
        path: "me",
        name: "me",
        component: () => import("../views/Profile/Me"),
        meta: {
          title: "My profile",
        },
      },
      {
        path: "me/edit",
        name: "edit profile",
        components: {
          default: () => import("../views/Profile/Edit"),
          back: () => import("../components/NavigateBack"),
        },
        meta: {
          title: "My profile",
          sub: true,
        },
      },
      {
        path: "about",
        name: "About",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/About.vue"),
        meta: {
          title: "About",
        },
      },
      {
        path: "records",
        component: TopNavLayout,
        children: [
          {
            path: "",
            name: "consultations",
            components: {
              default: () => import("../views/MyRecords/Consultations"),
              nav: RecordsNav,
            },
            meta: {
              title: "My Records",
            },
          },
          {
            path: "labs",
            name: "labs",
            components: {
              default: () => import("../views/MyRecords/Labs"),
              nav: RecordsNav,
            },
            meta: {
              title: "My Records",
            },
          },
          {
            path: "vaccines",
            name: "vaccine",
            components: {
              default: () => import("../views/MyRecords/Vaccines"),
              nav: RecordsNav,
            },
            meta: {
              title: "My Records",
            },
          },
        ],
      },
      {
        path: "consultations/:encounter_id/children",
        name: "consultation children",
        components: {
          default: () => import("../views/MyRecords/ConsultationWithChildren"),
          back: NavigateBack,
        },
        meta: {
          title: " ",
          sub: true,
        },
        props: {
          default: true,
        },
      },
    ],
    meta: {
      requiresAuth: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(function (to, from, next) {
  if (
    to.matched.some((record) => record.meta.addPatient || record.meta.privacy)
  ) {
    gtag("config", "UA-179188418-1", { page_path: to.path });
    next();
  } else if (to.matched.some((record) => record.meta.requiresGuest)) {
    if (localStorage.getItem("user")) {
      next(false);
    } else {
      gtag("config", "UA-179188418-1", { page_path: to.path });
      next();
    }
  } else if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!localStorage.getItem("user")) {
      next({ name: "login" });
    } else {
      gtag("config", "UA-179188418-1", { page_path: to.path });
      next();
    }
  }
});

export default router;
